// Libs
import React from 'react'
import { UploadCloud } from 'react-feather'

// CSS
import "./styles.scss"

const FeatureHistory = () => {
  let spans = []
  const spansCount = 50

  for (var i = 0; i < spansCount; i++) {
    spans = [...spans, 'span']
  }

  return (
    <div className="feature-history">
      {spans.map((item, idx) => (
        <span
          key={idx}
          style={{
            marginTop: `${idx * -3}vw`,
            marginLeft: `${idx * -3}vw`,
            zIndex: spansCount - idx,
            opacity: 0.5 - (0.03 * idx)
          }} />
      ))}
      <div>
        <UploadCloud />
      </div>
    </div>
  )
}

export default FeatureHistory
